import { sva } from "@stubhub/broadway-foundation/css";

const performerEventGridListItemBodyContentSlots = [
  "fallbackFlagContainer",
  "fallbackFlag",
  "title",
  "festivalHeadlinerSubtitle",
] as const;

export const performerEventGridListItemBodyContentRecipe = sva({
  slots: performerEventGridListItemBodyContentSlots,
  className: "performerEventGridListItemBodyContent",
  base: {
    fallbackFlagContainer: {
      display: "inline-flex",
      height: "[16px]",
      aspectRatio: "3 / 2",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "bg.surface.stronger",
      borderStartRadius: "primitives.50",
      borderEndRadius: "primitives.50",
    },
    fallbackFlag: {
      color: "text.subtle",
    },
    title: {
      verticalAlign: "middle",
    },
    festivalHeadlinerSubtitle: {
      fontWeight: "semibold",
      color: "text",
    },
  },
});
